<div class="provider-filter" 
     *ngIf="specialities?.length || insurances?.length || cities?.length">
  <div class="provider-container">
    <div class="img-conrainer">
      <img src="/assets/Illo-Frame.svg" />
    </div>
    <div class="body-text">
      <h2>Browse more therapists</h2>
      <p class="iris-mt-02">Find a therapist that fits your needs</p>
    </div>
  </div>

  <div class="search-by-type" *ngIf="specialities?.length > 0">
    <h3>Search by Specialty</h3>
    <ng-container *ngFor="let speciality of specialities">
      <a
        [href]="
          providerDirectoryUrl +
          '/' +
          uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
          '/' +
          uriPrefix.CITY + '-' + emptyURIValue +
          '/' +
          uriPrefix.SPECIALTY + '-' + speciality.uriSafeValue
        "
        target="_blank"
      >
        {{ speciality.value }}
      </a>
    </ng-container>
  </div>

  <div class="search-by-type" *ngIf="insurances?.length > 0">
    <h3>Search by Insurance</h3>
    <ng-container *ngFor="let insurance of insurances">
      <a
        class="subtitle"
        [href]="
          providerDirectoryUrl +
          '/' +
          uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
          '/' +
          uriPrefix.CITY + '-' + emptyURIValue +
          '/' +
          uriPrefix.INSURANCE + '-' + insurance.uriSafeValue
        "
        target="_blank"
      >
        {{ insurance.value }}
      </a>
    </ng-container>
  </div>

  <div class="search-by-type" *ngIf="cities?.length > 0">
    <h3>Search by City</h3>
    <ng-container *ngFor="let city of cities">
      <a
        class="subtitle"
        [href]="
          providerDirectoryUrl +
          '/' +
          uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
          '/' +
          uriPrefix.CITY + '-' + city.uriSafeValue
        "
        target="_blank"
      >
        {{ city.value }}
      </a>
    </ng-container>
  </div>
</div>
